import { render, staticRenderFns } from "./QuestionButton.vue?vue&type=template&id=76acc63a&"
import script from "./QuestionButton.vue?vue&type=script&lang=js&"
export * from "./QuestionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports